import React from 'react';
import './HintButton.css';

const HintButton = ({ onClick, arrowText, ariaLabel }) => {
  return (
    <button
      className="hint-button"
      onClick={onClick}
      aria-label={ariaLabel}
    >
      {arrowText}
    </button>
  );
};

export default HintButton;